// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buscador-torneo {
  height: 5vh;
  position: relative;
  display: flex;
  width: 100%;
  background-color: rgba(56, 51, 51, 0.8);
  text-align: center;
  border-radius: 10px;
}

.input-torneo {
  width: 100%;
  font-size: medium;
  color: white;
  text-align: center;
}

.input-torneo::placeholder {
  color: white;
}

[data-theme='light'] .input-torneo,
[data-theme='light'] .input-torneo::placeholder {
  color: black;
}


[data-theme='light'] .buscador-torneo {
  background-color: rgba(204, 197, 176, 0.8);
}

input {
  border: none;
  outline: none;
  width: 100%;
  background: transparent;
  opacity: 0.8;
  margin-left: 1.5vh;
}

button {
  background: transparent;
  display: inline-table;
  border: none;
  cursor: pointer;
  font-size: medium;
}

button svg {
  height: 3vh;
  width: auto;
  color: rgb(175, 167, 165);
}

[data-theme='light'] button svg {
  color: rgb(102, 86, 64);
}

.ul-buscador {
  list-style-type: none;
  position: absolute;
  top: 5vh;
  max-height: 30vh;
  width: 100%;
  overflow-y: auto;
}

.ul-buscador p {
  background-color: rgb(34, 97, 83);
  color: rgb(218, 208, 208);
}

[data-theme='light'] .ul-buscador p {
  background-color: #DBD4BE;
  color: rgb(99, 89, 79);
}

.nombre-item {
  cursor: pointer;
}

.contenedor-rondas-buttons {
  display: flex;
  overflow-x: auto;
}

.contenedor-rondas-buttons button {
  margin-right: 10px;
  background-color: rgba(88, 87, 87, 0.7);
  height: auto;
  width: 4vh;
  border-radius: 15%;
}

.ronda-seleccionada {
  margin-bottom: 0;
  border: 0.2vw solid rgba(177, 147, 50, 0.7);
  color: black;
}

[data-theme='light'] .ronda-seleccionada {
  background-color: rgb(228, 228, 226);
  color: black;
}

[data-theme='light'].contenedor-rondas-buttons button {
  margin-right: 10px;
  background-color: rgba(158, 155, 155, 0.7);
}
`, "",{"version":3,"sources":["webpack://./src/Components/Tennis/Buscadores/Buscador_torneo/Buscador_torneo.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,uCAAuC;EACvC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;;AAGA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;AAC5C","sourcesContent":[".buscador-torneo {\n  height: 5vh;\n  position: relative;\n  display: flex;\n  width: 100%;\n  background-color: rgba(56, 51, 51, 0.8);\n  text-align: center;\n  border-radius: 10px;\n}\n\n.input-torneo {\n  width: 100%;\n  font-size: medium;\n  color: white;\n  text-align: center;\n}\n\n.input-torneo::placeholder {\n  color: white;\n}\n\n[data-theme='light'] .input-torneo,\n[data-theme='light'] .input-torneo::placeholder {\n  color: black;\n}\n\n\n[data-theme='light'] .buscador-torneo {\n  background-color: rgba(204, 197, 176, 0.8);\n}\n\ninput {\n  border: none;\n  outline: none;\n  width: 100%;\n  background: transparent;\n  opacity: 0.8;\n  margin-left: 1.5vh;\n}\n\nbutton {\n  background: transparent;\n  display: inline-table;\n  border: none;\n  cursor: pointer;\n  font-size: medium;\n}\n\nbutton svg {\n  height: 3vh;\n  width: auto;\n  color: rgb(175, 167, 165);\n}\n\n[data-theme='light'] button svg {\n  color: rgb(102, 86, 64);\n}\n\n.ul-buscador {\n  list-style-type: none;\n  position: absolute;\n  top: 5vh;\n  max-height: 30vh;\n  width: 100%;\n  overflow-y: auto;\n}\n\n.ul-buscador p {\n  background-color: rgb(34, 97, 83);\n  color: rgb(218, 208, 208);\n}\n\n[data-theme='light'] .ul-buscador p {\n  background-color: #DBD4BE;\n  color: rgb(99, 89, 79);\n}\n\n.nombre-item {\n  cursor: pointer;\n}\n\n.contenedor-rondas-buttons {\n  display: flex;\n  overflow-x: auto;\n}\n\n.contenedor-rondas-buttons button {\n  margin-right: 10px;\n  background-color: rgba(88, 87, 87, 0.7);\n  height: auto;\n  width: 4vh;\n  border-radius: 15%;\n}\n\n.ronda-seleccionada {\n  margin-bottom: 0;\n  border: 0.2vw solid rgba(177, 147, 50, 0.7);\n  color: black;\n}\n\n[data-theme='light'] .ronda-seleccionada {\n  background-color: rgb(228, 228, 226);\n  color: black;\n}\n\n[data-theme='light'].contenedor-rondas-buttons button {\n  margin-right: 10px;\n  background-color: rgba(158, 155, 155, 0.7);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
